import { render } from "./IconInvoice.vue?vue&type=template&id=39c7cc52"
import script from "./IconInvoice.vue?vue&type=script&lang=js"
export * from "./IconInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__